import { FC } from "react";

import { PageContextWrapper } from "@ryde/controls";
import { LayoutCrudRoutes, PageClientSideFilters } from "@ryde/layout";

import { PanelTopLeftProduceButton } from "./parts";

const entity = "produceButton";

export const ProduceButtonsPage: FC = () => {
  return (
    <PageContextWrapper entity={entity}>
      <PageClientSideFilters
        BottomWidgetComponent={<PanelTopLeftProduceButton />}
      />
      <LayoutCrudRoutes />
    </PageContextWrapper>
  );
};
